import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import { AuthService } from '../../services/auth-service/auth.service';

@Component({
    selector: 'app-control-correct',
    templateUrl: './control-correct.component.html',
    styleUrls: ['./control-correct.component.scss'],
    standalone: false
})
export class ControlCorrectComponent implements OnInit {
  labels;
  labelsSub: Subscription;
  user
  userSub: Subscription
  buttons
  constructor(private authService: AuthService, public dialogRef2: MatDialogRef<ControlCorrectComponent>, public adminLanguageService: AdminLanguageService) { }

  ngOnInit(): void {
    this.getLang()
    this.userSub = this.authService.user$.subscribe((user: User) => {
      this.user = user;
      console.log(this.user)
      setTimeout(() => {
        if(this.user.companyId == 1){
          this.buttons = "buttonEMS"

        }else if(this.user.companyId == 2){
          this.buttons = "buttonECG"
        }
        else{
          this.buttons = "buttonECG"
        }
      }, 200);
    });
  }

  onNoClick(){
    this.dialogRef2.close()
  }

  getLang(){
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
      })
  }
}
